export enum ConfirmationStatus {
  Pending = 'Pending',
  AwaitingConfirmation = 'Awaiting Confirmation',
  Confirmed = 'Confirmed'
}
